import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

export default function DashboardNav() {
  const { profile, signOut } = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const role = profile?.role;

  const primaryLinks = [
    { label: '내 정보', path: '/my-profile', icon: 'ri-user-settings-line' },
    { label: '내 검사결과', path: '/my-results', icon: 'ri-file-list-3-line' },
    { label: '문의', path: '/inquiry', icon: 'ri-chat-3-line' },
  ];

  const adminLink =
    role === 'operator'
      ? { label: '운영 관리', path: '/admin', icon: 'ri-shield-check-line' }
      : role === 'owner'
        ? { label: '학원 관리', path: '/admin', icon: 'ri-building-2-line' }
        : role === 'member'
          ? { label: '내 이용권', path: '/admin', icon: 'ri-vip-crown-line' }
          : null;

  const go = (path: string) => {
    setMenuOpen(false);
    navigate(path);
  };

  const handleSignOut = () => {
    setMenuOpen(false);
    signOut();
  };

  return (
    <header className="sticky top-0 z-40 bg-white border-b border-background-200 print:hidden">
      <div className="max-w-7xl mx-auto px-4 md:px-6 h-16 flex items-center justify-between">
        {/* Logo */}
        <button onClick={() => go('/')} className="flex items-center gap-2 cursor-pointer">
          <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100 text-primary-700">
            <i className="ri-graduation-cap-line text-lg"></i>
          </div>
          <span className="font-heading font-bold text-foreground-950 text-lg whitespace-nowrap">
            MC에듀
          </span>
        </button>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-1">
          {primaryLinks.map((link) => (
            <button
              key={link.path}
              onClick={() => go(link.path)}
              className="whitespace-nowrap inline-flex items-center gap-1.5 px-3 py-2 rounded-md text-sm text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
            >
              <i className={link.icon}></i>
              {link.label}
            </button>
          ))}
          {adminLink && (
            <button
              onClick={() => go(adminLink.path)}
              className="whitespace-nowrap inline-flex items-center gap-1.5 px-3 py-2 rounded-md text-sm text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
            >
              <i className={adminLink.icon}></i>
              {adminLink.label}
            </button>
          )}
          <button
            onClick={handleSignOut}
            className="whitespace-nowrap inline-flex items-center gap-1.5 px-3 py-2 ml-1 rounded-md text-sm text-foreground-700 hover:bg-red-50 hover:text-red-600 transition-colors cursor-pointer"
          >
            <i className="ri-logout-box-r-line"></i>
            로그아웃
          </button>
        </nav>

        {/* Mobile hamburger */}
        <button
          onClick={() => setMenuOpen((v) => !v)}
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-700 hover:bg-background-100 cursor-pointer"
        >
          <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden border-t border-background-200 bg-white px-4 py-3 space-y-1">
          {primaryLinks.map((link) => (
            <button
              key={link.path}
              onClick={() => go(link.path)}
              className="w-full text-left flex items-center gap-2 px-3 py-2.5 rounded-md text-sm text-foreground-700 hover:bg-background-100 cursor-pointer"
            >
              <i className={link.icon}></i>
              {link.label}
            </button>
          ))}
          {adminLink && (
            <button
              onClick={() => go(adminLink.path)}
              className="w-full text-left flex items-center gap-2 px-3 py-2.5 rounded-md text-sm text-foreground-700 hover:bg-background-100 cursor-pointer"
            >
              <i className={adminLink.icon}></i>
              {adminLink.label}
            </button>
          )}
          <button
            onClick={handleSignOut}
            className="w-full text-left flex items-center gap-2 px-3 py-2.5 rounded-md text-sm text-red-600 hover:bg-red-50 cursor-pointer"
          >
            <i className="ri-logout-box-r-line"></i>
            로그아웃
          </button>
        </div>
      )}
    </header>
  );
}